import { fg } from '@atlassian/jira-feature-gating';

const BoardJISDevSummaryField = {
	get(): boolean {
		return fg('dis-14_use_jis_dev_summary');
	},
};

// eslint-disable-next-line import/no-default-export
export default BoardJISDevSummaryField;
